import * as mutationsNames from './mutationNames';

export default {
    state: {
        isCheckedShowButtonSetZero: localStorage.checkedShowButtonZero ? localStorage.checkedShowButtonZero : false,
        dateDisplayFormats: ['YYYY-MM-DD', 'DD.MM.YYYY'],
        dateDisplayFormat: 'YYYY-MM-DD'
    },
    getters: {
        getValueCheckedShowButtonSetZero: (state) => {
            if (state.isCheckedShowButtonSetZero === "true")
                return true;
            else if (state.isCheckedShowButtonSetZero === "false")
                return false;
            return state.isCheckedShowButtonSetZero;
        },
        dateDisplayFormat: (state) => {
            return state.dateDisplayFormat
        },
        dateDisplayFormats: (state) => {
            return state.dateDisplayFormats
        }
    },
    mutations: {
        [mutationsNames.SET_CHECKED_SHOW_BUTTON_ZERO](state, value) {
            state.isCheckedShowButtonSetZero = value;
        },
        [mutationsNames.SET_DATE_DISPLAY_FORMAT] (state, value) {
            state.dateDisplayFormat = value
        }
    }
}